import React from 'react';

import V1Error from './V1Error';
import V2Error from './V2Error';

interface State {
  hasError: boolean;
  error?: V1Error | V2Error;
  errorInfo?: React.ErrorInfo;
}

interface Props {
  children: React.ReactNode;
  fallbackRender?: (state: Omit<State, 'hasError'>) => React.ReactNode;
}

export default class AppErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
    error: undefined,
    errorInfo: undefined,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: V1Error | V2Error, errorInfo: React.ErrorInfo) {
    // try-catch 혹은 suspense 핸들링 되지 않는 컴포넌트가 던진 커스텀 에러 로그
    console.error('Uncaught error in Error Boundary:', error, errorInfo);

    this.setState({
      ...this.state,
      error,
      errorInfo,
    });

    if (error instanceof V1Error || error instanceof V2Error) {
      error.executeErrorHandler(); // 커스텀 에러 클래스에 정의했던 에러 핸들러 실행
    }
  }

  render() {
    const { error, errorInfo } = this.state;

    if (this.state.hasError) {
      if (this.props.fallbackRender) {
        return this.props.fallbackRender({ error, errorInfo });
      }
    }

    return this.props.children;
  }
}
